import { render, staticRenderFns } from "./TituloConsultaBoletos.vue?vue&type=template&id=78d0de10&"
import script from "./TituloConsultaBoletos.vue?vue&type=script&lang=js&"
export * from "./TituloConsultaBoletos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports